import { render, staticRenderFns } from "./ViewReponseResidentsFeedbackModal.vue?vue&type=template&id=7ee2a56c&scoped=true&"
import script from "./ViewReponseResidentsFeedbackModal.vue?vue&type=script&lang=js&"
export * from "./ViewReponseResidentsFeedbackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee2a56c",
  null
  
)

export default component.exports